import { createSelector } from 'reselect';

const userProfileSelector = state => state.userProfile;

export const isLogin = createSelector(
  userProfileSelector,
  userProfile => !userProfile.loading && userProfile.data !== null
);

export const isLoading = createSelector(
  userProfileSelector,
  userProfile => userProfile.loading
);

export const isFirstTimeLogin = createSelector(
  userProfileSelector,
  userProfile => (userProfile.data !== null ? userProfile.data.isFirstTimeLogin : null)
);

export const loginError = createSelector(
  userProfileSelector,
  userProfile => userProfile.error
);

export const myProfile = createSelector(
  userProfileSelector,
  userProfile => userProfile.data
);

export const myRoles = createSelector(
  userProfileSelector,
  userProfile => (userProfile.data && userProfile.data.roles) || []
);
